var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _circle, _circle2, _circle3, _path, _path2, _rect60, _rect61, _rect62, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _rect63, _polygon, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationVmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vmc",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000.5 3001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#594b45;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-6,.cls-61,.cls-62,.cls-64,.cls-68,.cls-69,.cls-7,.cls-72,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-1{fill:url(#D\xE9grad\xE9_sans_nom_157);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_157-2);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_157-3);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_157-4);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_157-5);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_157-6);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_157-7);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_157-8);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_157-9);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_157-10);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_157-11);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_157-12);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_157-13);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_157-14);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_157-15);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_157-16);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_157-17);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_157-18);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_157-19);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_157-20);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_157-21);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_157-22);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_157-23);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_157-24);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_157-25);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_157-26);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_157-27);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_157-28);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_157-29);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_157-30);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_157-31);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_157-32);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_157-33);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_157-34);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_157-35);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_157-36);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_157-37);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_157-38);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_157-39);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_157-40);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_157-41);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_157-42);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_157-43);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_157-44);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_157-45);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_157-46);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_157-47);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_157-48);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_157-49);}.cls-50{fill:url(#D\xE9grad\xE9_sans_nom_157-50);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_157-51);}.cls-52{fill:url(#D\xE9grad\xE9_sans_nom_157-52);}.cls-53{fill:url(#D\xE9grad\xE9_sans_nom_157-53);}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_157-54);}.cls-55{fill:url(#D\xE9grad\xE9_sans_nom_157-55);}.cls-56{fill:url(#D\xE9grad\xE9_sans_nom_157-56);}.cls-57{fill:url(#D\xE9grad\xE9_sans_nom_157-57);}.cls-58{fill:url(#D\xE9grad\xE9_sans_nom_157-58);}.cls-59{fill:url(#D\xE9grad\xE9_sans_nom_63);}.cls-60{fill:#284934;opacity:0.75;}.cls-61,.cls-68{stroke-width:3px;}.cls-61{fill:url(#D\xE9grad\xE9_sans_nom_29);stroke:url(#D\xE9grad\xE9_sans_nom_34);}.cls-62,.cls-64,.cls-68,.cls-69,.cls-72{fill:none;}.cls-62{stroke:#efefef;}.cls-63{fill:#e2e2e2;}.cls-64{stroke:#4c4c4c;}.cls-64,.cls-72{stroke-width:2px;}.cls-65{fill:#515151;}.cls-66{fill:#c9c9c9;}.cls-67{fill:#8e8e8e;}.cls-68{stroke:#f2f2f2;}.cls-69{stroke:#7c7c7c;}.cls-70{fill:url(#D\xE9grad\xE9_sans_nom_91);}.cls-71{fill:url(#D\xE9grad\xE9_sans_nom_92);}.cls-72{stroke:#262626;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157",
    x1: 1509.5,
    y1: 2871.5,
    x2: 1509.5,
    y2: 2828.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#614533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a07860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a77d64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b2866b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c39376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#cf9b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c79678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ba8c70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a77e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b1856b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cf9c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c89678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bd8d70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ac8065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b5a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70513e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-2",
    x1: 709.5,
    x2: 709.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-3",
    x1: 2854.5,
    x2: 2854.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-4",
    x1: 2309.5,
    x2: 2309.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-5",
    x1: 1937.5,
    y1: 2827.5,
    x2: 1937.5,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-6",
    x1: 1137.5,
    y1: 2827.5,
    x2: 1137.5,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-7",
    x1: 369,
    y1: 2827.5,
    x2: 369,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-8",
    x1: 2668.5,
    y1: 2827.5,
    x2: 2668.5,
    y2: 2784.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-9",
    x1: 2070.26,
    y1: 2784.5,
    x2: 2070.26,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-10",
    x1: 1369.9,
    y1: 2784.5,
    x2: 1369.9,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-11",
    x1: 697.11,
    y1: 2784.5,
    x2: 697.11,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-12",
    x1: 187.56,
    y1: 2784.5,
    x2: 187.56,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-13",
    x1: 2710.22,
    y1: 2784.5,
    x2: 2710.22,
    y2: 2741.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-14",
    x1: 155,
    x2: 155,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-15",
    x1: 1137.5,
    y1: 2914.5,
    x2: 1137.5,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-16",
    x1: 1937.5,
    y1: 2914.5,
    x2: 1937.5,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-17",
    x1: 369,
    y1: 2914.5,
    x2: 369,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-18",
    x1: 187.5,
    y1: 2957.5,
    x2: 187.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-19",
    x1: 773.5,
    y1: 2957.5,
    x2: 773.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-20",
    x1: 1573.5,
    y1: 2957.5,
    x2: 1573.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-21",
    x1: 2373.5,
    y1: 2957.5,
    x2: 2373.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-22",
    x1: 2668.5,
    y1: 2914.5,
    x2: 2668.5,
    y2: 2871.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-23",
    x1: 405.5,
    y1: 3000.5,
    x2: 405.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-24",
    x1: 1209.5,
    y1: 3000.5,
    x2: 1209.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-25",
    x1: 2009.5,
    y1: 3000.5,
    x2: 2009.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-26",
    x1: 2704.5,
    y1: 3000.5,
    x2: 2704.5,
    y2: 2957.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-27",
    x1: 2886.5,
    y1: 2957.5,
    x2: 2886.5,
    y2: 2914.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-28",
    x1: 1509.5,
    y1: 2612.5,
    x2: 1509.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-29",
    x1: 709.5,
    y1: 2612.5,
    x2: 709.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-30",
    x1: 2854.5,
    y1: 2612.5,
    x2: 2854.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-31",
    x1: 2309.5,
    y1: 2612.5,
    x2: 2309.5,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-32",
    x1: 1937.5,
    y1: 2568.5,
    x2: 1937.5,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-33",
    x1: 1137.5,
    y1: 2568.5,
    x2: 1137.5,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-34",
    x1: 369,
    y1: 2568.5,
    x2: 369,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-35",
    x1: 2668.5,
    y1: 2568.5,
    x2: 2668.5,
    y2: 2525.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-36",
    x1: 2070.26,
    y1: 2525.5,
    x2: 2070.26,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-37",
    x1: 1369.9,
    y1: 2525.5,
    x2: 1369.9,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-38",
    x1: 697.11,
    y1: 2525.5,
    x2: 697.11,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-39",
    x1: 187.56,
    y1: 2525.5,
    x2: 187.56,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-40",
    x1: 2710.22,
    y1: 2525.5,
    x2: 2710.22,
    y2: 2482.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-41",
    x1: 155,
    y1: 2612.5,
    x2: 155,
    y2: 2569.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-42",
    x1: 1137.5,
    y1: 2655.5,
    x2: 1137.5,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-43",
    x1: 1937.5,
    y1: 2655.5,
    x2: 1937.5,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-44",
    x1: 369,
    y1: 2655.5,
    x2: 369,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-45",
    x1: 187.5,
    y1: 2698.5,
    x2: 187.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-46",
    x1: 773.5,
    y1: 2698.5,
    x2: 773.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-47",
    x1: 1573.5,
    y1: 2698.5,
    x2: 1573.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-48",
    x1: 2373.5,
    y1: 2698.5,
    x2: 2373.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-49",
    x1: 2668.5,
    y1: 2655.5,
    x2: 2668.5,
    y2: 2612.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-50",
    x1: 405.5,
    y1: 2741.5,
    x2: 405.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-51",
    x1: 1209.5,
    y1: 2741.5,
    x2: 1209.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-52",
    x1: 2009.5,
    y1: 2741.5,
    x2: 2009.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-53",
    x1: 2704.5,
    y1: 2741.5,
    x2: 2704.5,
    y2: 2698.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-54",
    x1: 2886.5,
    y1: 2698.5,
    x2: 2886.5,
    y2: 2655.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-55",
    x1: 405.5,
    y1: 2482.5,
    x2: 405.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-56",
    x1: 1209.5,
    y1: 2482.5,
    x2: 1209.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-57",
    x1: 2009.5,
    y1: 2482.5,
    x2: 2009.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-58",
    x1: 2704.5,
    y1: 2482.5,
    x2: 2704.5,
    y2: 2439.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_63",
    x1: 1500,
    x2: 1500,
    y2: 2438.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#325c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#436b54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3f6751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325c46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_29",
    x1: 1278.75,
    y1: 347.25,
    x2: 1636.25,
    y2: 347.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_34",
    x1: 1277.25,
    y1: 347.25,
    x2: 1637.75,
    y2: 347.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_91",
    x1: 2799,
    y1: 1219.06,
    x2: 2870,
    y2: 1219.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_92",
    x1: 1500,
    y1: 2439,
    x2: 1500,
    y2: 2353.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "r\xE9paration vmc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1109.5,
    y: 2828.5,
    width: 800,
    height: 43
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 309.5,
    y: 2828.5,
    width: 800,
    height: 43
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2709.5,
    y: 2828.5,
    width: 290,
    height: 43
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1909.5,
    y: 2828.5,
    width: 800,
    height: 43
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1537.5,
    y: 2784.5,
    width: 800,
    height: 43
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 737.5,
    y: 2784.5,
    width: 800,
    height: 43
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.5,
    y: 2784.5,
    width: 737,
    height: 43
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2337.5,
    y: 2784.5,
    width: 662,
    height: 43
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1720.08,
    y: 2741.5,
    width: 700.37,
    height: 43
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1019.71,
    y: 2741.5,
    width: 700.37,
    height: 43
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 374.5,
    y: 2741.5,
    width: 645.21,
    height: 43
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.5,
    y: 2741.5,
    width: 374.12,
    height: 43
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 2420.45,
    y: 2741.5,
    width: 579.55,
    height: 43
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0.5,
    y: 2828.5,
    width: 309,
    height: 43
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 737.5,
    y: 2871.5,
    width: 800,
    height: 43
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1537.5,
    y: 2871.5,
    width: 800,
    height: 43
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 0.5,
    y: 2871.5,
    width: 737,
    height: 43
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 0.5,
    y: 2914.5,
    width: 374,
    height: 43
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 373.5,
    y: 2914.5,
    width: 800,
    height: 43
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1173.5,
    y: 2914.5,
    width: 800,
    height: 43
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1973.5,
    y: 2914.5,
    width: 800,
    height: 43
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 2337.5,
    y: 2871.5,
    width: 662,
    height: 43
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 0.5,
    y: 2957.5,
    width: 810,
    height: 43
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 809.5,
    y: 2957.5,
    width: 800,
    height: 43
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1609.5,
    y: 2957.5,
    width: 800,
    height: 43
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 2409.5,
    y: 2957.5,
    width: 590,
    height: 43
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 2773.5,
    y: 2914.5,
    width: 226,
    height: 43
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1109.5,
    y: 2569.5,
    width: 800,
    height: 43
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 309.5,
    y: 2569.5,
    width: 800,
    height: 43
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 2709.5,
    y: 2569.5,
    width: 290,
    height: 43
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1909.5,
    y: 2569.5,
    width: 800,
    height: 43
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1537.5,
    y: 2525.5,
    width: 800,
    height: 43
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 737.5,
    y: 2525.5,
    width: 800,
    height: 43
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 0.5,
    y: 2525.5,
    width: 737,
    height: 43
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 2337.5,
    y: 2525.5,
    width: 662,
    height: 43
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1720.08,
    y: 2482.5,
    width: 700.37,
    height: 43
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1019.71,
    y: 2482.5,
    width: 700.37,
    height: 43
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 374.5,
    y: 2482.5,
    width: 645.21,
    height: 43
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 0.5,
    y: 2482.5,
    width: 374.12,
    height: 43
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 2420.45,
    y: 2482.5,
    width: 579.55,
    height: 43
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 0.5,
    y: 2569.5,
    width: 309,
    height: 43
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 737.5,
    y: 2612.5,
    width: 800,
    height: 43
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1537.5,
    y: 2612.5,
    width: 800,
    height: 43
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 0.5,
    y: 2612.5,
    width: 737,
    height: 43
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 0.5,
    y: 2655.5,
    width: 374,
    height: 43
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 373.5,
    y: 2655.5,
    width: 800,
    height: 43
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1173.5,
    y: 2655.5,
    width: 800,
    height: 43
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1973.5,
    y: 2655.5,
    width: 800,
    height: 43
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 2337.5,
    y: 2612.5,
    width: 662,
    height: 43
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 0.5,
    y: 2698.5,
    width: 810,
    height: 43
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 809.5,
    y: 2698.5,
    width: 800,
    height: 43
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1609.5,
    y: 2698.5,
    width: 800,
    height: 43
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 2409.5,
    y: 2698.5,
    width: 590,
    height: 43
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2773.5,
    y: 2655.5,
    width: 226,
    height: 43
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 0.5,
    y: 2439.5,
    width: 810,
    height: 43
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 809.5,
    y: 2439.5,
    width: 800,
    height: 43
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 1609.5,
    y: 2439.5,
    width: 800,
    height: 43
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 2409.5,
    y: 2439.5,
    width: 590,
    height: 43
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    width: 3000,
    height: 2438.11
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 1458.5,
    cy: 379.25,
    r: 178.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 1457.5,
    cy: 347.25,
    r: 178.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 1458.55,
    cy: 346.6,
    r: 144.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1368.75,272.22c46.33-52.75,138.29-49.9,178.21,0V413.1H1368.75Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1409.38,402c-12.41,3.79-35.64,12.12-49.19,10.7-7.84-9.27-21.38-42.78-21.38-65.59,0-67.74,51.78-123,119.52-123s119.29,55.23,119.29,123c-3.31,36.06-15.69,56.32-22.1,67-11.41,0-19.25-5-32.79-10",
    transform: "translate(0)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1375.88,
    y: 314.28,
    width: 160.39,
    height: 57.74
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1375.88,
    y: 351.35,
    width: 160.39,
    height: 11.72
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1375.88,
    y: 340.79,
    width: 160.39,
    height: 10.56
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1346.65,378.44s17.82.71,24.95,0,57.74-20,89.11-20",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1339.88,345.29s24.59,1.07,31.72.36,57.74-20,89.11-20",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1344.87,312.5s19.6,1.07,26.73.35,57.74-20,89.11-20",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1359.13,279.71s5.7,0,12.83-.72,57.38-18.17,88.75-18.17",
    transform: "translate(0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1570.84,378.44s-17.82.71-24.95,0-57.74-20-89.1-20",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1577.26,345.29s-20.67,1.07-27.8.36-57.74-20-89.11-20",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1572.27,313.21s-15.68.36-22.81-.36-57.74-20-89.11-20",
    transform: "translate(0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1557.3,279.71s-1.07,0-8.2-.72-57.38-18.17-88.75-18.17",
    transform: "translate(0)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-69",
    cx: 1458.32,
    cy: 346.4,
    rx: 144.75,
    ry: 145.1
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 2799,
    width: 71,
    height: 2438.11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "3000 2353.67 2870 2353.67 2865.32 2361.39 2806.79 2361.39 2799 2353.67 0 2353.67 0 2439 3000 2439 3000 2353.67"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    y1: 2439,
    x2: 3000,
    y2: 2439
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationVmc);
export default __webpack_public_path__ + "static/media/situation_vmc.f4ba30178865adabc25995839625a031.svg";
export { ForwardRef as ReactComponent };